import { ArrowForwardIcon } from '@chakra-ui/icons';
import { Box, Table, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react';
import { PermissionsV2 } from 'constants/permissions_v2';
import { TRANSACTION_FOR_APPROVAL_TABLE_HEADINGS } from 'modules/merchantinfo/constants/constants';
import { formatTransactionTime } from 'modules/merchantinfo/utils/utils';
import PermissionWrapper from 'components/hoc/PermissionWrapper';

const TransactionTable = ({ transactions, onTransactionClick, hideApproveButton = false }) => {
  return (
    <Box overflowX='auto' maxWidth='100%' style={{ borderWidth: '2px', borderRadius: '18px' }} mt={4}>
      <Table variant='simple'>
        <Thead>
          <Tr>
            {TRANSACTION_FOR_APPROVAL_TABLE_HEADINGS.map((heading, idx) => {
              if (heading === 'Description' || (heading === 'Action' && hideApproveButton)) {
                return null;
              }

              return heading == 'Action' ? (
                <PermissionWrapper permission={PermissionsV2.APPROVE_PAYMENTS}>
                  <Th key={idx}>{heading}</Th>;
                </PermissionWrapper>
              ) : (
                <Th key={idx}>{heading}</Th>
              );
            })}
          </Tr>
        </Thead>
        <Tbody>
          {transactions?.map((smbTransaction) => (
            <Tr
              key={smbTransaction?.Id}
              fontSize='sm'
              onClick={() => onTransactionClick(smbTransaction?.Id)}
              style={{ cursor: 'pointer' }}
              _hover={{ background: 'gray.100' }}
            >
              <Td>{formatTransactionTime(smbTransaction?.CreatedAt)}</Td>
              <Td color='gray'>{smbTransaction?.TransactionId ?? '-'}</Td>
              <Td fontWeight='bold'>{smbTransaction?.SourceAmount}</Td>
              <Td color='gray'>{smbTransaction?.SourceCurrencyCode ?? '-'}</Td>
              <Td fontWeight='bold'>debit</Td>
              <PermissionWrapper permission={PermissionsV2.APPROVE_PAYMENTS}>
                {!hideApproveButton && (
                  <Td color='green' fontWeight='bold'>
                    Approve <ArrowForwardIcon />
                  </Td>
                )}
              </PermissionWrapper>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Box>
  );
};

export default TransactionTable;
